import { uploadMedia, patchOrderStatusHistory } from '../../../app/api';
import { buildBudgetFilename } from '../../../extensions/price-simulator-3d/priceSimulationBudgetExport';

export function findLatestFieldEditHistoryId(order) {
  const history = order?.status_history;
  if (!Array.isArray(history) || history.length === 0) return null;
  const sorted = [...history].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  for (const ev of sorted) {
    if (!ev?.id) continue;
    const cf = ev.changed_fields;
    if (cf != null && String(cf).trim() !== '') {
      return ev.id;
    }
  }
  return null;
}

export async function uploadPngToOrderStatusHistory(orderId, historyId, pngBlob, title) {
  if (!orderId || !historyId || !pngBlob) return;
  const filename = title || 'orcamento-simulador.png';
  const file = new File([pngBlob], filename, { type: 'image/png' });
  const fd = new FormData();
  fd.append('file', file);
  fd.append('metadata_key', 'order_status_history');
  fd.append(
    'metadata_json',
    JSON.stringify({
      id: historyId,
      url: '',
      title: filename,
      order: 0,
    }),
  );
  await uploadMedia(fd);
}

export async function attachSimulatorBudgetToFieldEditHistory(orderId, historyId, note, pngBlob, description) {
  if (!orderId || !historyId) {
    throw new Error('history entry not found');
  }
  if (note && String(note).trim() !== '') {
    await patchOrderStatusHistory(orderId, historyId, { note: String(note).trim() });
  }
  if (pngBlob) {
    const filename = buildBudgetFilename({ description, format: 'png' });
    await uploadPngToOrderStatusHistory(orderId, historyId, pngBlob, filename);
  }
}
